import React, { Component } from "react";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import "./UserPreference.css"; // Assuming you have a CSS file named LanguageSelector.css

class UserPreference extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lazyLoading: false,
      open: false,
      selectedLanguage: "",
      selectedTheme: "",
      selectedFontSize: "", 
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  onCancel = () => {
    this.handleOpen();
  };

  handleLanguageChange = (language) => {
    this.setState({ selectedLanguage: language });
  
  };

  handleThemeChange = (theme) => {
    this.setState({ selectedTheme: theme });
   
  };

  handleFontSizeChange = (size) => {
    this.setState({ selectedFontSize: size });
    
  };

  // handleSubmit = () => {
  //   // Handle submit logic here
  //   const { selectedLanguage, selectedTheme, selectedFontSize } = this.state;

  //   // You can pass all the selected values to parent or handle as needed
  //  
  //   console.log("Submitted: ", { selectedLanguage, selectedTheme, selectedFontSize });
  // };
  handleSubmit = () => {
    const { selectedLanguage, selectedTheme, selectedFontSize } = this.state;
    console.log("Submitted: ", { selectedLanguage, selectedTheme, selectedFontSize });
    // sessionStorage.setItem("font", selectedFontSize);
    // sessionStorage.setItem("themeselction", selectedTheme,);
    // sessionStorage.setItem("lan", selectedLanguage);
    
    this.props.onLanguageSelect({
          language: selectedLanguage,
          theme: selectedTheme,
          fontSize: selectedFontSize,
        });
        this.handleClose()
  };

  render() {
    return (
      <>
        <div className="modalWrapper">
          <div className="modalContent">
            <IconButton
              size="small"
              color="secondary"
              aria-label="cancel"
              disabled={this.state.lazyLoading}
              onClick={this.onCancel}
            >
              {/* <CancelIcon /> */}
            </IconButton>

            {/* Language Selection */}
            <div className="contentWrapper">
              <h5 className="heading">Please select a language</h5>
              <div className="buttonGroup">
                <Button
                  variant={
                    this.state.selectedLanguage === "en"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleLanguageChange("en")}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                   
                  }}
                >
                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <span className="firstchar">Aa</span><p className="text">English</p>
                  </div>
                </Button>
                <Button
                  variant={
                    this.state.selectedLanguage === "hn"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleLanguageChange("hn")}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span className="firstchar">आ</span><p className="text">हिंदी</p>
                  </div>
                </Button>
                <Button
                  variant={
                    this.state.selectedLanguage === "od"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleLanguageChange("od")}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    
                  }}
                >
                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span className="firstchar">ଆ</span><p className="text">ଓଡିଆ</p>
                  </div>
                </Button>
              </div>
            </div>

           

            {/* Font Size Selection */}
            <div className="contentWrapper">
              <h5 className="heading">Please select font size</h5>
              <div className="buttonGroupfont">
                <Button
                 style={{backgroundColor:this.state.selectedFontSize === "small" ? "grey" : "white" , color: "rgba(12, 77, 162, 1)",fontSize:"16px",fontWeight:"700", boxShadow: "0px 5.43px 5.43px 0px rgba(0, 0, 0, 0.25)",margin:"0"}} 
                  variant={
                    this.state.selectedFontSize === "small"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleFontSizeChange("small")}
                >
                  <p className="fontselect" > SMALL</p>
                
                </Button>
                <Button
                 style={{ backgroundColor:this.state.selectedFontSize === "medium" ? "grey" : "white" , color: "rgba(12, 77, 162, 1)",fontSize:"16px",fontWeight:"700", boxShadow: "0px 5.43px 5.43px 0px rgba(0, 0, 0, 0.25)",margin:"0"}} 
                  variant={
                    this.state.selectedFontSize === "medium"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleFontSizeChange("medium")}
                >
                 <p className="fontselect">MEDIUM</p> 
                </Button>
                <Button
                 style={{backgroundColor:this.state.selectedFontSize === "large" ? "grey" : "white", color: " rgba(12, 77, 162, 1)" ,fontSize:"16px",fontWeight:"700", boxShadow: "0px 5.43px 5.43px 0px rgba(0, 0, 0, 0.25)",margin:"0"}} 
                  variant={
                    this.state.selectedFontSize === "large"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleFontSizeChange("large")}
                >
                 <p className="fontselect">LARGE</p> 
                </Button>
              </div>
            </div>
                   {/* Theme Selection */}
            <div className="contentWrapper">
              <h5 className="heading">Please select a theme</h5>
              <div className="buttonGrouptheme">
                <Button
                 style={{margin:"0"}}
                  variant={
                    this.state.selectedTheme === "LIGHT THEME"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleThemeChange("LIGHT THEME")}
                >
                 <p 
                 className="themefont">LIGHT THEME</p> 
                </Button>
                <Button
                 style={{margin:"0"}}
                  variant={
                    this.state.selectedTheme === "DARK THEME"
                      ? "contained"
                      : "outlined"
                  }
                  onClick={() => this.handleThemeChange("DARK THEME")}
                >
                 <p 
                 className="themefont">DARK THEME</p> 
                </Button>
              </div>
            </div>
            {/* Submit Button */}
            <div className="submitWrapper">
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>

        {/* Confirmation Dialog */}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Confirm Cancel</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to cancel?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              No
            </Button>
            <Button onClick={this.props.onCancel} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default UserPreference;

